import { withInstall } from '@park-ui/utils'

import Empty from './src/empty.vue'

export const ElEmpty = withInstall(Empty)
export default ElEmpty

export * from './src/empty'
